import { requestForm, requestJson } from "./quizApiClient";

export const listTopics = async ({ page = 1, limit, headers, all = false } = {}) => {
  const params = new URLSearchParams();

  if (all) {
    params.set("all", "true");
  } else {
    params.set("page", `${page}`);
    if (limit !== undefined && limit !== null) {
      params.set("limit", `${limit}`);
    }
  }

  return requestJson(`/api/topics?${params.toString()}`, {
    method: "GET",
    headers,
  });
};

export const createTopic = async ({ payload, headers }) => {
  return requestJson("/api/topics", {
    method: "POST",
    headers,
    body: payload,
  });
};

export const updateTopic = async ({ topicId, payload, headers }) => {
  return requestJson(`/api/topics/${topicId}`, {
    method: "PUT",
    headers,
    body: payload,
  });
};

export const deleteTopic = async ({ topicId, headers }) => {
  return requestJson(`/api/topics/${topicId}`, {
    method: "DELETE",
    headers,
  });
};

export const uploadDocument = async ({ file, topicId, headers }) => {
  const formData = new FormData();
  formData.append("file", file);
  if (topicId) {
    formData.append("topic_id", topicId);
  }

  return requestForm("/api/ingestion/upload", {
    method: "POST",
    headers,
    body: formData,
  });
};

export const listDocuments = async ({ page = 1, limit = 20, topicId, headers } = {}) => {
  const params = new URLSearchParams({ page: `${page}`, limit: `${limit}` });
  if (topicId) params.append("topic_id", topicId);
  return requestJson(`/api/ingestion/documents?${params.toString()}`, {
    method: "GET",
    headers,
  });
};

export const deleteDocument = async ({ source, topicId, headers }) => {
  const params = new URLSearchParams();
  if (topicId) params.append("topic_id", topicId);
  const suffix = params.toString() ? `?${params.toString()}` : "";
  return requestJson(`/api/ingestion/documents/${encodeURIComponent(source)}${suffix}`, {
    method: "DELETE",
    headers,
  });
};

export const generateQuestions = async ({ topicId, headers }) => {
  console.log("[quiz] generateQuestions", { topicId });
  return requestJson(`/api/questions/topics/${topicId}/generate`, {
    method: "POST",
    headers,
  });
};

export const getTopicStats = async ({ topicId, headers }) => {
  return requestJson(`/api/questions/topics/${topicId}/stats`, {
    method: "GET",
    headers,
  });
};

export const listTopicQuestions = async ({ topicId, page = 1, limit = 20, headers } = {}) => {
  console.log("[quiz] listTopicQuestions", { topicId, page, limit });
  return requestJson(`/api/questions/topics/${topicId}?page=${page}&limit=${limit}`, {
    method: "GET",
    headers,
  });
};

export const deleteTopicQuestions = async ({ topicId, headers }) => {
  return requestJson(`/api/questions/topics/${topicId}`, {
    method: "DELETE",
    headers,
  });
};

export const getGlobalQuestionStats = async ({ headers } = {}) => {
  return requestJson("/api/questions/stats", {
    method: "GET",
    headers,
  });
};

export const listReports = async ({ page = 1, limit = 20, headers } = {}) => {
  return requestJson(`/api/reports?page=${page}&limit=${limit}`, {
    method: "GET",
    headers,
  });
};

export const resolveReport = async ({ reportId, action, notes, headers }) => {
  return requestJson(`/api/reports/${reportId}/resolve`, {
    method: "PATCH",
    headers,
    body: {
      action,
      notes,
    },
  });
};

export const getReportStats = async ({ headers } = {}) => {
  return requestJson("/api/reports/stats", {
    method: "GET",
    headers,
  });
};

export const getQualityStats = async ({ headers } = {}) => {
  return requestJson("/api/reports/quality-stats", {
    method: "GET",
    headers,
  });
};

export const getQualityIssues = async ({ headers } = {}) => {
  return requestJson("/api/reports/quality-issues", {
    method: "GET",
    headers,
  });
};

export const getQualityByTopic = async ({ topicId, headers }) => {
  return requestJson(`/api/reports/quality/${topicId}`, {
    method: "GET",
    headers,
  });
};

export const triggerQualityCheck = async ({ headers } = {}) => {
  return requestJson("/api/reports/quality-check", {
    method: "POST",
    headers,
  });
};

export const getCacheStatus = async ({ topicId, headers }) => {
  return requestJson(`/api/quiz/cache/${topicId}/status`, {
    method: "GET",
    headers,
  });
};

export const clearCache = async ({ topicId, headers }) => {
  return requestJson(`/api/quiz/cache/${topicId}/clear`, {
    method: "DELETE",
    headers,
  });
};
